import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LocalizationService } from '../../services/localization.service';
import { FiltersColorHelper } from '../../../utils/helpers/filtersColorHelper';
import { environment } from '../../../../environments/environment';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-widget-staff-calendar',
  templateUrl: './widget-staff-calendar.html',
  styleUrls: ['./widget-staff-calendar.scss']
})
export class WidgetStaffCalendar implements OnInit {
  @Input({ required: true }) widgetData: any;
  LocalizationService = LocalizationService;
  FiltersColorHelper = FiltersColorHelper;

  eventsList: Array<any> = [];
  isLoading: boolean = false;
  utcCultureCode: string = 'he';

  constructor(
    private dataService: DataService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.utcCultureCode = this.dataService.getCultureCode().substring(0,2);
    this.getData();
  }

  filterChange(event: any, filterItem: any){
    filterItem.checked = event.checked;
    this.getData();
  }

  getData() {
    this.isLoading = true;
    let url = environment.apiUrl + '/Portal/Api/Widgets/GetStaffCalendarEvents';
    const selectedFilters = this.widgetData.filters.filter((f: { checked: boolean; }) => f.checked).map((x: { calendarType: number; }) => x.calendarType);

    let request: any = {
      cultureCode: this.dataService.getCultureCode(),
      filters: selectedFilters,
      maxDisplayItems: this.widgetData.maxItemsCount
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData: Array<any>) => {
        responseData.forEach(x => {
          // Parse startDate and endDate to Date objects
          x.startDate = new Date(x.startDate);
          x.endDate = new Date(x.endDate);
          x.isSameDay = this.isSameDay(x.startDate, x.endDate)
          // Find the itemType based on calendarType
          const itemType = this.widgetData.filters.find(
              (filter: { calendarType: any; }) => filter.calendarType === x.calendarType
          );

          if (itemType) {
              x.color = FiltersColorHelper.getStyleColor(itemType.color);
          }
        });
      
        this.eventsList = responseData;
        this.isLoading = false;
      },
      error: (e: any) => {
        console.error(e);
        this.isLoading = false;
        this.eventsList = [];
      },
    });
  }

  private isSameDay(firstDate: Date, secondDate: Date){
    return (
      firstDate.getFullYear() === secondDate.getFullYear() &&
      firstDate.getMonth() === secondDate.getMonth() &&
      firstDate.getDate() === secondDate.getDate()
    );
  }
}
